////////////////////////////////////////////////////////////////////////////////////////////////
// client_orbit - The orbit used on index
////////////////////////////////////////////////////////////////////////////////////////////////
(function ( $ ) {
    $.client_orbit = function ( ) {

		orbit_init();
		
		/**
		 * Running complete client orbit
		 * @return {Void}
		 */	    
		function orbit_init() { 
			
			// Vars
			var orbit_w = $( ".ld_slider" );
				
			// Settings
			orbit_settings( orbit_w );
			
			// UI
			fade_in( $( '#masterHeader') );
			fade_in( $( '#content') );
			fade_in( $( '.pre_footer') );
			fade_in( $( '.footer') );
			
			// prevent_exceed_viewport
			prevent_exceed_viewport( orbit_w );
			orbit_w.on('resizeme.zf.trigger', function(){ // https://codepen.io/zurbchris/pen/wMBQKX
				prevent_exceed_viewport( orbit_w );
			});	
			
		}
		
		/**
		 * orbit_settings
		 * @return {Void}
		 */	
		function orbit_settings( our_orbit ) {
			if ( our_orbit.length ) {
				var orbit = new Foundation.Orbit( our_orbit, {
					 
					animInFromLeft: 'fade-in',
					animInFromRight: 'fade-in',
					animOutToLeft: 'fade-out',
					animOutToight: 'fade-out',
					timerDelay: 3000, 
					pauseOnHover: false,
					navButtons: false,
					bullets: false
					
				});
			}		
		}
	
		/**
		 * Fade in after load
		 * @return {Void}
		 */		
		function fade_in( el ){
			if ( el.length ) {			
				el.fadeTo( "fast" , 1, function() {
					// Animation complete.
				});			
			} 
		}
	
		/**
		 * Prevent Orbit from exceeding viewport - Make sure the orbit images not exceed viewport height (if viewport height is less than orbit + header)
		 * @return {Void}
		 */		
		function prevent_exceed_viewport( our_orbit ){
			orbit_height = our_orbit.find( '.orbit-container' ).height();
			header_height = $( '#masterHeader' ).height();
			viewport_height = $( window ).height();
	
			content_we_want_above_the_fold_height = header_height + orbit_height;
			set_orbit_height_to = viewport_height - header_height;
					
			$.ld_debug( 'orbit_height: ' + orbit_height );
			$.ld_debug( 'header_height: ' + header_height );
			$.ld_debug( 'viewport_height: ' + viewport_height );
			$.ld_debug( 'content_we_want_above_the_fold_height: ' + content_we_want_above_the_fold_height );
			
			if ( viewport_height <= content_we_want_above_the_fold_height ) { // set height
				
				our_orbit.find( '.orbit-container' ).css( 'height', set_orbit_height_to );
				$( '.orbit-slide' ).css( 'margin-top', - (content_we_want_above_the_fold_height - set_orbit_height_to)  / 2);
				
				$.ld_debug( 'set_orbit_height_to: ' + set_orbit_height_to );
				$.ld_debug( '==== height on orbit ADJUSTED' );
				
			} else { // reset
				
				$( '.orbit-slide' ).css( 'margin-top', '0' );
				
				$.ld_debug( '==== height on orbit RESET' );
				
			}	
		}
	

    };
})( jQuery );


////////////////////////////////////////////////////////////////////////////////////////////////
// Youtube js api
////////////////////////////////////////////////////////////////////////////////////////////////

// https://css-tricks.com/play-button-youtube-and-vimeo-api/
// https://developers.google.com/youtube/iframe_api_reference

// global variable for the player
var player;

// this function gets called when API is ready to use
function onYouTubePlayerAPIReady() {
  // create the global player from the specific iframe (#video)
  player = new YT.Player('iframe_video', {
    events: {
      // call this function when player is ready to use
      'onReady': jQuery.on_player_ready
    }
  });
}

// Inject YouTube API script
var tag = document.createElement('script');
tag.src = "//www.youtube.com/player_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);



////////////////////////////////////////////////////////////////////////////////////////////////
// on_player_ready
////////////////////////////////////////////////////////////////////////////////////////////////
(function ( $ ) {
    $.on_player_ready = function ( ) {
	    
		//$.ld_debug('player ready');
		
		//////////////////////////
		// Play event
		//////////////////////////
		$( ".play_video" ).click(function() {
				
			$( '#youtube_modal' ).foundation( 'open' );
			adjust_the_video_size();
			player.playVideo();
			
		});


		//////////////////////////
		// Pause event
		//////////////////////////
		// @todo the escape button should also pause the video
		$( "#youtube_modal .js_close" ).click(function() {

			player.pauseVideo();
	
		});	
			
		function adjust_the_video_size() {
				
			var viewport_height = $( window ).height(); // Viewport
			var close_button_height = $( '.close_temp' ).outerHeight(); // Close button
			
			//$.ld_debug( viewport_height );
			//$.ld_debug( close_button_height );
			
			$( '#iframe_video' ).css( 'height', viewport_height - close_button_height ); // Setting the height	
			$( '.flex-video' ).css( 'height', viewport_height - close_button_height ); 				
			
		}

    };
    
})( jQuery );


////////////////////////////////////////////////////////////////////////////////////////////////
// client_scripts_ui
////////////////////////////////////////////////////////////////////////////////////////////////
(function ( $ ) {
    $.client_scripts_ui = function ( large_breakpoint, medium_breakpoint ) {
	    
	    // Cache some values here
	    var partners = $( '.partner_link' );
	    var padding = parseInt( partners.css( 'padding-left' ) );
		
		//////////////////////////
		// Init
		//////////////////////////
		adjust_main_logo( large_breakpoint );
		vertical_align_partner_logos( large_breakpoint );
		adjust_padding_footer( medium_breakpoint );
		
		// Fire for resize
		$(window).resize(function() {
			adjust_main_logo( large_breakpoint );
			vertical_align_partner_logos( large_breakpoint );
			adjust_padding_footer( medium_breakpoint );
		});
		
		
		/**
		 * Since the height of the top bar is set by the height of the menu, we need js to control the logo appearance
		 * @return {Void}
		 */		
		function adjust_main_logo( large_breakpoint ) {
			
			if ( window.innerWidth > large_breakpoint ) { 
				
				var header = $( '#masterHeader' );
				var logo = header.find( '.logo' );
				var header_height = header.height();
				
				// Set height (height ratio according to design)
				var isIE11 = !!window.MSInputMethodContext && !!document.documentMode; // IE11
				// http://stackoverflow.com/a/27971005
				// http://stackoverflow.com/a/21825207
				if ( !isIE11 ) {
					logo.find( 'img' ).css( 'height', header_height * 0.5 );
				}
				
				// Set padding for vertical alignment
				var logo_height = logo.height();
				var logo_padding = (header_height - logo_height) / 2;
				logo.css( 'padding-top', logo_padding );
				
			}
									
		}
		

		/**
		 * adjust_padding_footer
		 * @return {Void}
		 */			
		function adjust_padding_footer( medium_breakpoint ) {
			
			if ( window.innerWidth < medium_breakpoint ) { 
				
				var inner_footer = $( '#inner-footer .row' );
				
				var inner_footer_padding_bottom = parseInt( inner_footer.css( 'padding-bottom' ) );
				var scroll_top_icon_height = parseInt( $( '.scroll_top' ).css( 'height' ) );
				//$.ld_debug( inner_footer_padding_bottom );
				//$.ld_debug( scroll_top_icon_height );
				
				var new_padding_bottom = inner_footer_padding_bottom - scroll_top_icon_height;
				
				inner_footer.css( 'padding-bottom', new_padding_bottom );
				//$.ld_debug( new_padding_bottom );
				
			}
		}
		

		/**
		 * Vertical alignment of partner logos
		 * @return {Void}
		 */			
		function vertical_align_partner_logos( large_breakpoint ) {
			
			var outer_wrapper = $( '.cpt_partners .columns' ); 
			//outer_wrapper.css('background' , 'yellow'); // @todo, temp, remove
			var outer_wrapper_width = $( '.cpt_partners .columns' ).width(); 
			
			//$.ld_debug( 'outer_wrapper_width ' + outer_wrapper_width );
			
			var all_logo_width = [];
			
			
			/**
			 * @description Mods on the widths and height to get them the same size
			 * @return {Void}
			 */
			function make_same_size() {
				partners.each(function() {
								
					var partner_logo = $( this ).find( '.attachment-logo' );
		
					var logo_height = partner_logo.outerHeight();
					var logo_width = partner_logo.outerWidth();
								
					// Scaling _down_ logos that take up much space
					if ( logo_width > 220 && logo_height > 30 ) {
						partner_logo.prop( 'width', '180' );
					}
					
					// Scaling _up_ logos that take up little space
					if ( logo_width < 120 ) {
						partner_logo.prop( 'width', '160' );
					}
					
					var wrapper = $( this );
					var wrapper_width = wrapper.outerWidth();
					
					// Build array with all widths
					all_logo_width.push( wrapper_width );
					
				});
			}
			
			/**
			 * @description Calculations
			 * @return {Int} Percentage we need to scale down
			 */
			function do_calculations() {
				//$.ld_debug( 'all_logo_width ' + all_logo_width );	
				
				// Calculation on the total width of all logos
				var total_width = 0;
				for ( var i = 0; i < all_logo_width.length; i++ ) {
				    total_width += all_logo_width[i] << 0;
				}
				
				//$.ld_debug( 'total_width ' + total_width );
				
				// Calculation for how much reduction we need
				var total_width_status 				= ( outer_wrapper_width / total_width );
				var size_should_be_in_percent 		= total_width_status;
				
				//$.ld_debug( 'total_width_status ' + total_width_status );
				//$.ld_debug( 'size_should_be_in_percent ' + size_should_be_in_percent );	
				
				return size_should_be_in_percent;
			}
	
			/**
			 * @description Make the reduction on the width to make it fit the viewport
			 * @param {Int/String} size Percentage we need to scale down
			 * @return {Void}
			 */
			function reduce_sizes( size ) {
				
				
				var padding_new = Math.floor( padding * size );
				
				partners.each(function() {
		
					//////////////////////////
					// Reduce the logo
					//////////////////////////
					var partner_logo = $( this ).find( '.attachment-logo' );
					var logo_width = partner_logo.outerWidth();
					
					var logo_width_new = Math.floor( logo_width * size );
					
					// Set
					partner_logo.prop( 'width', logo_width_new );
					
					//////////////////////////
					// Reduce the padding
					//////////////////////////
					//$.ld_debug( 'padding ' + padding );
					//$.ld_debug( padding_new );
					
					// Set
					partners.css( 'padding-left', padding_new - 2 );
					partners.css( 'padding-right', padding_new - 2 );
					
				});			
			}
			
			///////////////// 
			// Init
			/////////////////
			make_same_size();
			
			// Medium screen, do resize
			// @todo, this should fire on browser resize also
			if ( window.innerWidth > large_breakpoint ) { 
				reduce_sizes( do_calculations() );
			} 			
		}

    };
})( jQuery );


////////////////////////////////////////////////////////////////////////////////////////////////
// client_scripts_events
////////////////////////////////////////////////////////////////////////////////////////////////
(function ( $ ) {
    $.client_scripts_user_events = function ( ) {
	    
	    bindRevealEvents();	    
		
		/**
		 * @desc Bind handlers to the relevant Foundation events
		 * @return (Void)
		 */
		function bindRevealEvents() {
		    $(window).on(
		        'open.zf.reveal', function () {
			        
		            reposition_modal_content('#menuModal .menu');
		            
		        }
		    );
		}
		
		/**
		 * @desc Mobile menu modal
		 * @param (String) el
		 * @return (Void)
		 */
		function reposition_modal_content( el ) {
		    var window_height = $( window ).height();
		    var menu = $( el );
		    var menu_height = menu.height();
		    var padding_top = (window_height - menu_height) / 2;
		
			menu.css('padding-top', padding_top);
		}
	
    };
})( jQuery );